export const INVESTMENT_PLAN = {
    INVESTMENT_PER_PAYMENT : 'INVESTMENT_PER_PAYMENT',
    TOTAL_FREEDOM : 'TOTAL_FREEDOM'
  }